// App related config
export default {
  APP_ID: 'smartforms.public',
  AUTH_CLIENT_ID: 'smartforms',
  DATE_FORMAT: 'DD.MM.YYYY',
  DATE_TIME_FORMAT: 'DD.M.YYYY HH:mm',
  CREATED_DATE_FORMAT: 'dddd, DD.MM.YYYY',
};
